module.exports = __webpack_public_path__ + "img/numberQuotient.1a61639c.png";